import React from "react";

import { usePerformanceTrackingChartMetric } from "../hooks/use-chart-state";

import { KpiChart } from "./kpi-chart/kpi-chart";
import { SpendChart } from "./spend-chart/spend-chart";

export function TrackingChart() {
  const [chartMetric] = usePerformanceTrackingChartMetric();
  const isSpendMetric = chartMetric === "spend";

  return (
    <>
      <div className="pt-1"></div>
      {isSpendMetric ? <SpendChart /> : <KpiChart />}
    </>
  );
}
